export default __webpack_public_path__ + "static/media/Refined Elixir of Precision.f262647f.jpg";